export const setFactoryList = (state, payload) => {	
	state.factoryList = payload;
}

export const setPackageList = (state, payload) => {	
	state.packageList = payload;
}

export const setVehicleList = (state, payload) => {
	state.vehicleList = payload;
}

export const setProductConfig = (state, payload) => { 
	for ( var k in payload.config.product_config ) {
		for (var n in payload.products) {
			if (payload.config.product_config[k].code.toString().replace(/ /g, '') == payload.products[n].pli_code.toString().replace(/ /g, '')) {				
				payload.products[n].calc_mode = payload.config.product_config[k].calc_mode == 'null' ? 1 : parseInt(payload.config.product_config[k].calc_mode);
				payload.products[n].factories = payload.config.product_config[k].factories.toString().split(",");
				payload.products[n].normalize_qty = payload.config.product_config[k].normalize_qty == 0 ? false : true;				
			} else {
				if ( payload.products[n].calc_mode == undefined || payload.products[n].calc_mode == null ) {
					payload.products[n].calc_mode = 1
					payload.products[n].factories = [];
					payload.products[n].normalize_qty = false;
				}				
			}		
		}
	}	
	var productConfig = [];	
	var factories = [];
	for (var k in payload.config.factories) {
		factories.push({ id: payload.config.factories[k].id, text: payload.config.factories[k].name});		
	}	
	var productConfig = { products: payload.products, product_config: payload.config.product_config, factories: factories };	
	state.productConfig = productConfig;
}

export const setTransportMatrix = (state, payload) => {
	var tcmItems = [];
	for ( var p in payload.tcm.items ) {
		var tcmItem = { id: payload.tcm.items[p].id, product_code: payload.tcm.items[p].product_code, uom: payload.tcm.items[p].uom, radius_cost: [] }  
		for (var r in payload.tcm.items[p].radius_cost) {
			tcmItem.radius_cost.push(payload.tcm.items[p].radius_cost[r].cost);			
		}		
		tcmItems.push(tcmItem);		
	}	
	var objProducts = [];
	for (var k in payload.products) {
		objProducts.push({ id: payload.products[k].pli_code, text: payload.products[k].pli_code + ' - ' + payload.products[k].pli_description});
	}
	var transportMatrix = { products: objProducts, tcmItems: tcmItems, structure: payload.tcm.structure, uom: payload.tcm.uom };
	state.transportMatrix = transportMatrix;		
}

export const fncEmptyMatrix = (state, payload) => {	
	state.transportMatrix = [];
}

export const fncProductConfigLoad = (state, payload) => {
	state.productConfig = [];
}

export const setObjFactoryEdit = (state, payload) => {
	for (var k in state.factoryList) {
		if (state.factoryList[k].id === payload.id) {			
			state.objFactoryEdit = state.factoryList[k];
		}
	}
}

export const setObjPackageAdd = (state, payload) => {	
	var objProducts = [];
	for (var k in payload.products) {
		objProducts.push({ id: payload.products[k].pli_code, text: payload.products[k].pli_code + ' - ' + payload.products[k].pli_description });
	}
	state.objPackageAddProducts = objProducts;
}

export const setObjPackageEdit = (state, payload) => {	
	var editObj = [];	
	for (var k in state.packageList) {
		if (state.packageList[k].id === payload.id) {
            editObj = state.packageList[k];			
		}
	}
	var objProducts = [];
	for (var p in payload.products) {
	  for (var k in payload.packageProducts) {		
			if (payload.packageProducts[k].product_code == payload.products[p].pli_code) {				
				payload.packageProducts[k].description = payload.products[p].pli_description;
			}
	  }
	  objProducts.push({ id: payload.products[p].pli_code, text: payload.products[p].pli_code + ' - ' + payload.products[p].pli_description });	  
	}	
	state.objPackageEdit = { package: editObj, products: objProducts, packageProducts: payload.packageProducts };
	state.objPackageEditProducts = payload.packageProducts;
}

export const fncRemovePackageProduct = (state, payload) => {	
	var objDelete = [];	
	for (var k in state.objPackageEditProducts) {		
		if (payload != state.objPackageEditProducts[k].product_code) {
			objDelete.push(state.objPackageEditProducts[k]);
		}
	}
	state.objPackageEditProducts = objDelete;	
}

export const fncAddPackageProduct = (state, payload) => {
	var objAdd = [];
	objAdd.push({ 'product_code': '', 'capacity': '', 'description': '' });
	for (var k in state.objPackageEditProducts) {		
		objAdd.push(state.objPackageEditProducts[k]);		
	}
	state.objPackageEditProducts = objAdd;
}

export const fncAddPackageProductNew = (state, payload) => {
	var objAdd = [];
	objAdd.push({ 'product_code': '', 'capacity': '', 'description': '' });
	for (var k in state.objPackageAdd) {
		objAdd.push(state.objPackageAdd[k]);
	}	
	state.objPackageAdd = objAdd;
}

export const setObjVehicleEdit = (state, payload) => {
	for (var k in state.vehicleList) {
		if (state.vehicleList[k].id === payload.id) {
			state.objVehicleEdit = state.vehicleList[k];
		}
	}
}

export const setRunSave = (state, payload) => {
	state.runSave = payload;
}

export const fncPopulateStructure = (state, payload) => {	
	var objStructure = [];
	for (var s in payload.structure) {
		objStructure.push({ id: payload.structure[s].id, radius: payload.structure[s].radius });		
	}
	state.transportStructure = objStructure;
}

export const fncDeleteRadius = (state, payload) => {
	var objStructure = [];
	for (var s in state.transportStructure) {
		if (state.transportStructure[s].id != payload) {
			objStructure.push({ id: state.transportStructure[s].id, radius: state.transportStructure[s].radius });
		}	
	}
	state.transportStructure = objStructure;
}

export const fncSetVehicleOptions = (state, payload) => {
	state.objVehicleEditMatrix = payload.matrix.vehicle_min_cost_matrix_items;
	state.objVehicleEditSelectedPackages = payload.packages.vehicle_packages;
	var objPackages = [];
	for ( var k in payload.packages.packages ) {
		objPackages.push({ id: payload.packages.packages[k].id, text: payload.packages.packages[k].name });
	}
	state.objVehicleEditPackages = objPackages;
}

export const fncAddvehicleMatrix = (state, payload) => {
	var objAdd = [];
	objAdd.push({ 'distance': '', 'cost': '' });
	for (var k in state.objVehicleEditMatrix) {
		objAdd.push(state.objVehicleEditMatrix[k]);
	}
	state.objVehicleEditMatrix = objAdd;
}

export const fncAddVehiclePackage = (state, payload) => {
	var objAdd = [];
	objAdd.push({ 'package': '', 'quantity': '' });
	for (var k in state.objVehicleEditSelectedPackages) {
		objAdd.push(state.objVehicleEditSelectedPackages[k]);
	}
	state.objVehicleEditSelectedPackages = objAdd;
}

export const fncDeleteVehicleMatrix = (state, payload) => {
	var objMatrix = [];
	for (var k in state.objVehicleEditMatrix) {
		if (state.objVehicleEditMatrix[k].distance != payload.id) {
			objMatrix.push(state.objVehicleEditMatrix[k]);
		}
	}
	state.objVehicleEditMatrix = objMatrix;	
}

export const fncDeleteVehiclePackage = (state, payload) => {
	var objPackage = [];
	for (var k in state.objVehicleEditSelectedPackages) {
		if (state.objVehicleEditSelectedPackages[k].package != payload.id) {
			objPackage.push(state.objVehicleEditSelectedPackages[k]);
		}
	}
	state.objVehicleEditSelectedPackages = objPackage;
}

export const setObjVehicleAdd = (state, payload) => {	
	var objPackages = [];
	for (var k in payload.packages.packages) {
		objPackages.push({ id: payload.packages.packages[k].id, text: payload.packages.packages[k].name });
	}	
	state.objVehicleEditPackages = objPackages;    
}

export const fncAddvehicleMatrixNew = (state, payload) => {
	var objAdd = [];
	objAdd.push({ 'distance': '', 'cost': '' });
	for (var k in state.objVehicleAddMatrix) {
		objAdd.push(state.objVehicleAddMatrix[k]);
	}
	state.objVehicleAddMatrix = objAdd;
}

export const fncAddVehiclePackageNew = (state, payload) => {
	var objAdd = [];
	objAdd.push({ 'package': '', 'quantity': '' });
	for (var k in state.objVehicleAddSelectedPackages) {
		objAdd.push(state.objVehicleAddSelectedPackages[k]);
	}
	state.objVehicleAddSelectedPackages = objAdd;
}

export const fncDeleteVehicleMatrixNew = (state, payload) => {
	var objMatrix = [];
	for (var k in state.objVehicleAddMatrix) {
		if (state.objVehicleAddMatrix[k].distance != payload.id) {
			objMatrix.push(state.objVehicleAddMatrix[k]);
		}
	}
	state.objVehicleAddMatrix = objMatrix;
}

export const fncDeleteVehiclePackageNew = (state, payload) => {
	var objPackage = [];
	for (var k in state.objVehicleAddSelectedPackages) {
		if (state.objVehicleAddSelectedPackages[k].package != payload.id) {
			objPackage.push(state.objVehicleAddSelectedPackages[k]);
		}
	}
	state.objVehicleAddSelectedPackages = objPackage;
}

export const fncAddRadius = (state, payload) => {
	var objRadius = [];
	objRadius.push({ id: '', radius: '' });
	for (var s in state.transportStructure) {		
		objRadius.push({ id: state.transportStructure[s].id, radius: state.transportStructure[s].radius });		
	}
	state.transportStructure = objRadius;
}

export const fncAddMatrix = (state, payload) => {
	var objMatrix = [];
	if (state.transportMatrix.tcmItems.length != 0 ) {
		var radiusLength = state.transportMatrix.tcmItems[0].radius_cost.length;		
		objMatrix.push({ 'id': '0', 'product_code': '', 'uom': '1', 'radius_cost': ['0', '0'] });
		for (var k in state.transportMatrix.tcmItems) {
			objMatrix.push(state.transportMatrix.tcmItems[k]);
		}
	}	
	state.transportMatrix.tcmItems = objMatrix;
}

export const fncDeleteMatrix = (state, payload) => {
	var objMatrix = [];
	for (var k in state.transportMatrix.tcmItems ) {
		if (state.transportMatrix.tcmItems[k].product_code != payload.id) {
			objMatrix.push(state.transportMatrix.tcmItems[k]);
		}
	}
	state.transportMatrix.tcmItems = objMatrix;
}

export const fncSetPackagesLoaded = (state, payload) => {
	state.packagesLoaded = payload;
}

export const fncSetVehiclesLoaded = (state, payload) => {
	state.vehiclesLoaded = payload;
}